import { render, staticRenderFns } from "./Place.vue?vue&type=template&id=492d9f86&scoped=true"
import script from "./Place.vue?vue&type=script&lang=js"
export * from "./Place.vue?vue&type=script&lang=js"
import style0 from "./Place.vue?vue&type=style&index=0&id=492d9f86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492d9f86",
  null
  
)

export default component.exports